<template>
        <div :style="{ visibility: Display ? 'visible' : 'hidden' }" class="pc-sheet">

          <!-- Header -->
          <div class="pc-header">
            <span class="pc-title">Add&nbsp;<span>{{ publication.text }}</span>&nbsp;to playlist</span>
            <button class="pc-close" @click="close" aria-label="Close">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>

          <!-- Search -->
          <div class="pc-search-wrap">
            <svg class="pc-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
              <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
            </svg>
            <input
              v-model="query"
              class="pc-search"
              placeholder="Search playlists…"
              ref="searchRef"
            />
            <button v-if="query" class="pc-search-clear" @click="query = ''">✕</button>
          </div>

          <!-- List -->
          <div class="pc-list" ref="pcList">
            <div v-if="!filtered.length && !showCreate" class="pc-empty">
              <p>No playlists found</p>
            </div>

            <button
              v-for="playlist in filtered"
              :key="playlist.id"
              class="pc-item"
              :class="{ 'pc-item--added': addedIds.has(playlist.id) }"
              @click="pick(playlist)"
            >
              <!-- Thumbnail -->
              <div class="pc-thumb">
                <img
                  v-if="playlist.cover"
                  :src="$store.state.baseUrl + 'images/' + playlist.cover"
                />
                <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="18" height="18">
                  <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
                </svg>
              </div>

              <!-- Info -->
              <div class="pc-item-body">
                <span class="pc-item-name">{{ playlist.name }}</span>
                <span class="pc-item-count">{{ (playlist.audios || []).length }} tracks</span>
              </div>

              <!-- State icon -->
              <div class="pc-item-end">
                <svg v-if="addedIds.has(playlist.id)" viewBox="0 0 24 24" fill="none" stroke="#00e5ff" stroke-width="2.5" width="15" height="15">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
                <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15" class="pc-add-icon">
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
              </div>
            </button>
          </div>

          <!-- Quick-create -->
          <div class="pc-create">
              <div v-if="showCreate" class="pc-create-row">
                <input
                  v-model="newName"
                  class="pc-create-input"
                  placeholder="Playlist name…"
                  @keydown.enter.prevent="createAndPick"
                  @keydown.esc="showCreate = false"
                  ref="createRef"
                  maxlength="60"
                />
                <button class="pc-create-confirm" @click="createAndPick" :disabled="!newName.trim()">
                  <svg style="min-width: 24px;width: 24px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="14" height="14">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </button>
                <button class="pc-create-cancel" @click="showCreate = false; newName = ''">
                  <svg style="min-width: 24px;width: 24px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="14" height="14">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>

            <button v-if="!showCreate" class="pc-new-btn" @click="openCreate">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="14" height="14">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              New playlist
            </button>
          </div>

        </div>
</template>

<script>
export default {
  name: 'PlaylistChooser',
  data() {
    return {
      Display:false,
      query:      '',
      newName:    '',
      showCreate: false,
      addedIds:   new Set(),
      publication:{}
    }
  },

  computed: {
    playlists() {
      return this.$store.state.playLists || []
    },
    filtered() {
      const q = this.query.trim().toLowerCase()
      if (!q) return this.playlists
      return this.playlists.filter(p => p.name.toLowerCase().includes(q))
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.searchRef) this.$refs.searchRef.focus()
    })
  },

  methods: {
    close () {
        this.Display = false
    },
    show (pub) {
        this.publication = pub
        this.addedIds = new Set()
        this.Display = true
        // adding in addedIds all playlists already containing this publication
        this.playlists.forEach(pl => {
          const pubIndex = pl.audios.findIndex(aud => aud._id === pub._id )
          if(pubIndex !== -1) this.addedIds.add(pl.id)
        });
    },
    updatePlaylists (playlist) {
      const index = this.playlists.findIndex(p => p.id === playlist.id);
      if(index == -1) return
      this.playlists[index] = playlist
      this.$store.commit('setPlayLists',this.playlists)
    },
    async pick(playlist) {
      if (this.addedIds.has(playlist.id)) {
        const index = playlist.audios.findIndex(aud => aud._id === this.publication._id)
        if (index === -1) return
        playlist.audios.splice(index, 1)
        this.updatePlaylists(playlist)
        this.addedIds.delete(playlist.id)
        return
      }

      // ← add this before committing
      await this.cachePublicationImage(this.publication)

      this.$store.commit('addPlayLists', { playListId: playlist.id, audio: this.publication })
      this.addedIds = new Set([...this.addedIds, playlist.id])
    },

    async cachePublicationImage(pub) {
      if (!('caches' in window)) return
      const cache   = await caches.open('audio-cache-v1')
      const baseUrl = this.$store.state.baseUrl + 'images/'

      const userProfile = this.$store.state.users[pub.userId] || {}
      const urls = [
        pub.img     ? baseUrl + pub.img     : null,
        pub.imgMini ? baseUrl + pub.imgMini : null,
        userProfile.profilImgMini1 ? baseUrl + userProfile.profilImgMini1 : null
      ].filter(Boolean)

      await Promise.all(urls.map(async (url) => {
        try {
          const already = await cache.match(url)
          if (already) return
          const response = await fetch(url)
          if (response.ok) await cache.put(url, response)
        } catch (e) {
          console.warn('Image cache failed for', url, e)
        }
      }))
    },

    openCreate() {
      this.showCreate = true
      this.$nextTick(() => {
        if (this.$refs.createRef) this.$refs.createRef.focus()
      })
    },

    async createAndPick() {
      const name = this.newName.trim()
      if (!name) return
        // Creates the playlist then adds the track in one action.
        // Adjust the action name/payload to match your store.
        const newPlaylist = {
          id: Date.now(),
          name: name,
          audios: []
        };
        const playlists = this.playlists
        playlists.push(newPlaylist)

        this.$store.commit('setPlayLists',playlists)
        const pcList = this.$refs.pcList
        this.$nextTick(() => {
          pcList.scrollTo({
            top: pcList.scrollHeight,
            behavior: 'smooth'
          })
        })

        this.newName = ''
        this.showCreate = false
    },
  },
}
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=DM+Mono:wght@400;500&display=swap');
 */
 .pc-sheet {
  position: sticky;
  bottom: 100%;
  left: 100%;
  width: 100%;
  max-width: 480px;
  max-height: 100%;
  background: #0d1117;
  border-top: 1px solid rgba(255,255,255,0.07);
  display: flex;
  flex-direction: column;
  font-family: 'DM Sans', sans-serif;
  color: #e2e8f0;
  overflow: hidden;
}

.pc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 18px 12px;
  flex-shrink: 0;
}

.pc-title {
  display: flex;
  font-size: 17px;
  font-weight: 600;
  color: #f1f5f9;
}
.pc-title > span {
  display: inline-block;
  max-width: 150px;
  color: #0099cc;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pc-close {
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
  color: rgba(255,255,255,0.35);
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: color 0.15s, background 0.15s;
}
.pc-close:hover { color: #e2e8f0; background: rgba(255,255,255,0.07); }
.pc-close svg { width: 18px; height: 18px; }

.pc-search-wrap {
  display: flex;
  align-items: center;
  margin: 0 16px 12px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 11px;
  padding: 0 12px;
  flex-shrink: 0;
  transition: border-color 0.2s;
}
.pc-search-wrap:focus-within {
  border-color: rgba(0,229,255,0.3);
  background: rgba(0,229,255,0.03);
}
.pc-search-wrap > * + * { margin-left: 10px; }

.pc-search-icon { color: rgba(255,255,255,0.3); flex-shrink: 0; }
.pc-search-icon svg { width: 16px; height: 16px; }

.pc-search {
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: #e2e8f0;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  padding: 11px 0;
}
.pc-search::placeholder { color: rgba(255,255,255,0.22); }

.pc-search-clear {
  background: none;
  border: none;
  color: rgba(255,255,255,0.3);
  cursor: pointer;
  font-size: 13px;
  padding: 0;
  line-height: 1;
  transition: color 0.15s;
}
.pc-search-clear:hover { color: rgba(255,255,255,0.7); }

.pc-list {
  flex: 1;
  overflow-y: auto;
  padding: 2px 0;
  scrollbar-width: thin;
}
.pc-list::-webkit-scrollbar       { width: 3px; }
.pc-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 3px; }

.pc-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 36px 24px;
  color: rgba(255,255,255,0.2);
  font-size: 14px;
}
.pc-empty p { margin: 0; }

.pc-item {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s;
  color: #e2e8f0;
}
.pc-item > * + * { margin-left: 14px; }
.pc-item:hover    { background: rgba(255,255,255,0.04); }
.pc-item:disabled { cursor: default; }
.pc-item--added   { opacity: 0.6; }

.pc-thumb {
  width: 48px;
  height: 48px;
  border-radius: 9px;
  background: rgba(255,255,255,0.06);
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255,255,255,0.25);
}
.pc-thumb img { width: 100%; height: 100%; object-fit: cover; }
.pc-thumb svg { width: 20px; height: 20px; }

.pc-item-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.pc-item-body > * + * { margin-top: 3px; }

.pc-item-name {
  font-size: 14px;
  font-weight: 500;
  color: #f1f5f9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pc-item-count {
  font-family: 'DM Mono', monospace;
  font-size: 12px;
  color: rgba(255,255,255,0.28);
}

.pc-item-end {
  flex-shrink: 0;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pc-item-end svg { width: 17px; height: 17px; }
.pc-add-icon { color: rgba(255,255,255,0.2); transition: color 0.15s; }
.pc-item:hover .pc-add-icon { color: #00e5ff; }

.pc-create {
  flex-shrink: 0;
  border-top: 1px solid rgba(255,255,255,0.06);
  padding: 12px 16px 18px;
}

.pc-new-btn {
  display: flex;
  align-items: center;
  background: none;
  border: 1px dashed rgba(255,255,255,0.12);
  border-radius: 11px;
  width: 100%;
  padding: 11px 16px;
  color: rgba(255,255,255,0.4);
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s, background 0.2s;
}
.pc-new-btn > * + * { margin-left: 10px; }
.pc-new-btn svg { width: 16px; height: 16px; }
.pc-new-btn:hover {
  border-color: rgba(0,229,255,0.3);
  color: #00e5ff;
  background: rgba(0,229,255,0.04);
}

.pc-create-row {
  display: flex;
  align-items: center;
}
.pc-create-row > * + * { margin-left: 8px; }

.pc-create-input {
  flex: 1;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(0,229,255,0.25);
  border-radius: 9px;
  outline: none;
  color: #e2e8f0;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  padding: 10px 13px;
  transition: border-color 0.2s;
}
.pc-create-input:focus        { border-color: rgba(0,229,255,0.5); }
.pc-create-input::placeholder { color: rgba(255,255,255,0.22); }

.pc-create-confirm,
.pc-create-cancel {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.15s, background 0.15s;
}
.pc-create-confirm {
  background: linear-gradient(135deg, #00e5ff, #0099cc);
  color: #fff;
}
.pc-create-confirm svg { width: 16px; height: 16px; }
.pc-create-confirm:disabled { opacity: 0.3; cursor: default; }

.pc-create-cancel {
  background: rgba(255,255,255,0.06);
  color: rgba(255,255,255,0.45);
}
.pc-create-cancel svg { width: 16px; height: 16px; }
.pc-create-cancel:hover { background: rgba(255,255,255,0.1); color: #e2e8f0; }

@media (max-width: 640px) {
  .pc-sheet {
    position: fixed;
    left: 0%;
    min-height: 100%;
    bottom: 0%;
  }
}

/* ════════════════════════════════════════════════════
   Small-screen override — restore original proportions
   ════════════════════════════════════════════════════ */
@media (max-width: 340px) {
  .pc-header { padding: 16px 16px 10px; }

  .pc-title       { font-size: 15px; }
  .pc-title > span { max-width: 120px; }

  .pc-close svg   { width: 16px; height: 16px; }

  .pc-search-wrap { margin: 0 14px 10px; padding: 0 10px; border-radius: 10px; }
  .pc-search-wrap > * + * { margin-left: 8px; }
  .pc-search-icon svg { width: 14px; height: 14px; }
  .pc-search      { font-size: 13px; padding: 9px 0; }
  .pc-search-clear { font-size: 12px; }

  .pc-empty       { font-size: 13px; }

  .pc-item        { padding: 8px 14px; }
  .pc-item > * + * { margin-left: 12px; }

  .pc-thumb       { width: 42px; height: 42px; border-radius: 8px; }
  .pc-thumb svg   { width: 18px; height: 18px; }

  .pc-item-name   { font-size: 13px; }
  .pc-item-count  { font-size: 11px; }
  .pc-item-body > * + * { margin-top: 2px; }

  .pc-item-end    { width: 20px; }
  .pc-item-end svg { width: 15px; height: 15px; }

  .pc-create      { padding: 10px 14px 16px; }

  .pc-new-btn     { padding: 9px 14px; font-size: 13px; border-radius: 10px; }
  .pc-new-btn > * + * { margin-left: 8px; }
  .pc-new-btn svg { width: 14px; height: 14px; }

  .pc-create-input  { font-size: 13px; padding: 8px 11px; border-radius: 8px; }

  .pc-create-confirm,
  .pc-create-cancel { width: 32px; height: 32px; border-radius: 8px; }
  .pc-create-confirm svg,
  .pc-create-cancel svg { width: 14px; height: 14px; }
}
</style>